import request from '@/utils/request'

export const getUserList = ({ page, size, userType, userName }) => {
  return request({
    url: `/upms/user/${page}/${size}`,
    params: {
      userType,
      userName
    }
  })
}

export const postUserEdit = (data) => {
  return request({
    method: 'post',
    url: '/upms/user',
    data
  })
}

export const putUserAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/user',
    data
  })
}

export const getUserDetail = (id) => {
  return request({
    url: `/upms/user/${id}`
  })
}

export const deleteUserDel = (id) => {
  return request({
    method: 'delete',
    url: `/upms/user/${id}`
  })
}

// 用户角色
export const putUserRoleAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/userrole',
    data
  })
}

export const deleteUserRoleDel = (id) => {
  return request({
    method: 'delete',
    url: `/upms/userrole/${id}`
  })
}

export const getUserRoleList = (userId) => {
  return request({
    url: `/upms/userrole/${userId}`
  })
}

export const delUserRoleList = (ids) => {
  return request({
    method: 'delete',
    url: '/upms/userrole/all',
    ids
  })
}

export const getUserInfo = (id) => {
  return request({
    url: '/home/userInfo'
  })
}
